import { PAYMENT_METHODS } from 'src/common/enums';
export * from './cardconnect';
export * from './cybersource';

export interface BreakdownItem {
  label: string;
  value: number;
  key?: string;
}

export interface PaymentFeesSummary {
  total?: number;
}

export interface PaymentFees {
  ccFee?: number | null;
  ccTotal?: number | null;
  achFee?: number | null;
  achTotal?: number | null;
  checkFee?: number | null;
  checkTotal?: number | null;
  breakdown?: BreakdownItem[];
  summary?: PaymentFeesSummary;
}

export interface PaymentSuccessInfo {
  id?: string;
  paymentConfirmation?: string;
}

export interface PaymentState {
  isInitialized?: boolean;
  isLoading?: boolean;
  paymentCheckFailed?: boolean;
  paymentFees?: PaymentFees;
  paymentID?: number | string | null;
  paymentFailed?: boolean;
  paymentSuccesInfo?: PaymentSuccessInfo | null;
  formData?: unknown; // Shared information across be/fe depends on payment provider
  selectedPaymentMethod?: PAYMENT_METHODS;
  signatoryName?: string | null;
  status?: string;
}

export enum PAYMENT_PROVIDER {
  CARD_CONNECT = 'cardconnect',
  CERTIFIED_PAYMENTS = 'certifiedpayments',
  CYBERSOURCE = 'cybersource',
  GENERIC = 'generic',
  HAMER = 'hamer',
  HEARTLAND = 'heartland',
  INTELLIPAY = 'intellipay',
  STRIPE = 'stripe',
  XPRESS_BILL_PAY = 'xpressbillpay',
}

export type PaymentMethod =
  (typeof PAYMENT_METHODS)[keyof typeof PAYMENT_METHODS];

export interface GenericPaymentsResponse {
  checkout_mode?: 'post_redirect' | 'redirect';
  formData: Record<string, unknown>;
  url: string;
}
